'use client'
import styled from 'styled-components'
import { getStyledCounterStyles } from './style'
import { StyledCounterProps } from './type'

const StyledCounter = styled.div.withConfig({
    shouldForwardProp: (prop) => !['backgroundColor'].includes(prop)
})<StyledCounterProps>(({ theme, backgroundColor }) =>
    getStyledCounterStyles({ theme, backgroundColor })
)

export default StyledCounter
